import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { withRouter } from "react-router";
import STRINGS from "Constants/Strings";
import "./ConfirmPopupModal.scss";

class ConfirmPopupModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: props.showModal,
    };
  }

  handleClose = () => {
    this.setState({ show: false });
  };

  render() {
    const {
      title,
      description,
      toggleModal,
      yesBtnClick,
      noBtnClick,
      closeBtnClick,
    } = this.props;

    const { show } = this.state;

    return (
      <>
        <Modal
          show={show}
          onHide={() => {
            this.handleClose();
            toggleModal();
            closeBtnClick();
          }}
          className="[ confirm-popup-modal__container ]"
          aria-labelledby="confirm-popup-modal-title"
          aria-describedby="confirm-popup-modal-description"
          centered
        >
          <Modal.Header className="[ confirm-popup-modal__header ]" closeButton>
            <Modal.Title
              id="confirm-popup-modal-title"
              className="[ icon confirm-popup-modal-delete-icon ]"
            >
              {title}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="[ confirm-popup-modal__body ]">
            <div
              id="confirm-popup-modal-description"
              className="[ confirm-popup-modal-message__title ]"
            >
              {description}
            </div>
          </Modal.Body>

          <Modal.Footer className="[ confirm-popup-modal-footer ] [ popup-modal-footer ] [ d-block ]">
            <div className="[ mb-3 text-center ]">
              <button
                type="button"
                onClick={() => {
                  this.handleClose();
                  toggleModal();
                  yesBtnClick();
                }}
                className="[ btn btn-info w-75 ] [ confirm-popup-modal-footer__okBtn submit-btn ]"
              >
                {STRINGS.VAULT.DELETE_CONFIRM}
              </button>
            </div>

            <div className="[ divider mb-3 d-flex align-items-center ]"></div>

            <div className="[ mb-3 text-center forgot-link ]">
              <button
                type="button"
                onClick={() => {
                  this.handleClose();
                  toggleModal();
                  noBtnClick();
                }}
                className="[ link ]"
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  textDecoration: "underline",
                  color: "rgb(0, 144, 198)",
                  cursor: "pointer",
                }}
              >
                {STRINGS.VAULT.DELETE_CANCEL}
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

ConfirmPopupModal.propTypes = {
  showModal: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  toggleModal: PropTypes.func,
  yesBtnClick: PropTypes.func,
  noBtnClick: PropTypes.func,
  closeBtnClick: PropTypes.func,
};

ConfirmPopupModal.defaultProps = {
  showModal: false,
  title: "",
  description: "",
  toggleModal: () => {},
  yesBtnClick: () => {},
  noBtnClick: () => {},
  closeBtnClick: () => {},
};

export default withRouter(ConfirmPopupModal);
